module.exports = __webpack_public_path__ + "static/media/Line-Awesome.4d5a0ee1.ttf";